import { render } from "./Suporte.vue?vue&type=template&id=65903c2b&scoped=true"
import script from "./Suporte.vue?vue&type=script&lang=js"
export * from "./Suporte.vue?vue&type=script&lang=js"

import "./Suporte.vue?vue&type=style&index=0&id=65903c2b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65903c2b"]])

export default __exports__